module.exports = function (app, mod, nft_overlay) {
  var nft = nft_overlay.nft;
  var capabilities = nft_overlay.capabilities;
  var text = '';
  if (nft.text) {
    text = nft.text;
  }
  if (nft.css) {
    text = nft.css;
  }
  if (nft.js) {
    text = nft.js;
  }
  if (nft.json) {
    text = nft.json;
  }
  var esc = function esc(value) {
    return app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
  };
  var rawImageUrl = (nft === null || nft === void 0 ? void 0 : nft.image) || '/saito/img/dreamscape.png';
  var imageUrl = app.browser.isSafeMediaUrl(rawImageUrl) ? rawImageUrl : '/saito/img/dreamscape.png';
  var textHtml = text ? "<div class=\"saito-nft-text\">".concat(esc(text), "</div>") : '';
  var capsHtml = capabilities ? capabilities.renderHtml() : '';
  var metaHtml = capabilities ? capabilities.footerMetaHtml(nft) : '';
  return "\n    <div class=\"saito-nft-panel saito-nft-panel-view active\">\n      <div class=\"saito-nft-panel-body saito-nft-panel-body-view\">\n        <div class=\"saito-nft-image\" style=\"background-image:url('".concat(esc(imageUrl), "')\">\n          ").concat(textHtml, "\n          ").concat(nft.expires_at != null && nft.expires_at !== '' ? "<div class=\"saito-nft-expires-clock\">".concat(nft.remainingExpiresLabel(), "</div>") : '', "\n          <div class=\"saito-nft-capability-chrome\">\n            <div class=\"saito-nft-capabilities\" role=\"toolbar\" aria-label=\"NFT capabilities\">\n              ").concat(capsHtml, "\n            </div>\n            <div class=\"saito-nft-capability-desc is-empty\" aria-live=\"polite\"></div>\n          </div>\n        </div>\n      </div>\n      <footer class=\"saito-nft-panel-footer saito-nft-panel-footer-view\">\n        <div class=\"saito-nft-footer-meta\">").concat(metaHtml, "</div>\n      </footer>\n    </div>\n  ");
};